// src/pageConfig.js
import React, { useMemo } from "react";
import { TbBuildingWarehouse, TbHome2, TbCalendar, TbClipboardCheck, TbClipboardList, TbUserPlus, TbClipboardPlus, TbCreditCard, TbFileInvoice, TbInfoCircle, TbMail, TbNotes, TbReceipt, TbUserShield, TbUserStar, TbRobot, TbMessages, TbLayoutDashboard, TbShieldLock, TbBook, TbShoppingBag, TbDiscount, TbListCheck, TbCirclePlus, TbSettings } from "react-icons/tb";
import { useAuth } from "./AuthContext";
import { merchantHasDepoType, merchantHasNakliyeType } from "./utils/merchantNavigation";
import { MERCHANT_OVERVIEW_ENABLED } from "./utils/merchantPayouts";
import {
  ALL_ACCESS,
  getCapabilities,
  normalizeRole,
  isSuperadmin,
  buildDefaultPermissions,
  canView as frontAuthCanView,
  canManagePermissions,
  mergeMissingPagePermissions,
} from "./utils/frontAuth";
import {
  normalizeMerchantRole,
  buildMerchantDefaultPermissions,
  mergeMissingMerchantPagePermissions,
  getMerchantCapabilities,
  canView as merchantCanView,
  canManageMerchantPermissions,
} from "./utils/merchantFrontAuth";

// Ham (rolsüz) liste: Filtreyi sonra uygulayacağız
const RAW_PAGE_LIST = [
  {
    title: "Genel Bakış",
    items: [
      { text: "Genel Bakış", icon: <TbLayoutDashboard strokeWidth={1} />, path: "/overview", exact: true, role: "admin" },
      // Anasayfa müşteride ve merchant'ta görünür (merchant'ta izin matrisine takılmaz —
      // bkz. merchantItemVisible / ProtectedRoute'taki "homepage" istisnası).
      { text: "Anasayfa", icon: <TbHome2 strokeWidth={1} />, path: "/homepage", exact: true, role: ["customer", "merchant"] },
      // Partner Genel Bakış: Yaklaşan / Yapılan Ödemeler. Yetki matrisinde "Genel Bakış" olarak
      // görünür; default yalnız firma Yöneticisi (merchantFrontAuth). ŞİMDİLİK GİZLİ:
      // MERCHANT_OVERVIEW_ENABLED (utils/merchantPayouts) false iken menüde ve matriste yok.
      ...(MERCHANT_OVERVIEW_ENABLED
        ? [{ text: "Genel Bakış", icon: <TbLayoutDashboard strokeWidth={1} />, path: "/merchant-overview", exact: true, role: "merchant" }]
        : []),
      // Merchant'ın firma ayarları Anasayfa'nın hemen altında durur; müşteriye dokunan
      // sayfalar (Müşterilerim, Ödemeler, Sözleşmeler) "Müşteri Yönetimi" grubunda.
      {
        text: "Firma Profili",
        icon: <TbNotes strokeWidth={1} />,
        path: "/my-warehouse-firm",
        role: "merchant",
      },
      {
        text: "Depo Listesi",
        icon: <TbClipboardList strokeWidth={1} />,
        path: "/warehouse-list",
        role: "merchant",
      },
    ],
  },
  {
    title: "Mesajlaşma",
    items: [
      // TROYİ (yapay zekâ asistanı) sohbeti Mesajlar'ın ÜSTÜNDE durur.
      { text: "TROYİ'ye Sor", icon: <TbRobot strokeWidth={1} />, path: "/ask-troyi", role: "merchant" },
      // Müşteride Mesajlar "Destek" kategorisinde listelenir (aşağıda).
      { text: "Mesajlar", icon: <TbMessages strokeWidth={1} />, path: "/chat", role: ["admin", "merchant"] },
    ],
  },
  {
    title: "Talepler",
    items: [
      {
        text: "Talep Oluştur",
        icon: <TbClipboardPlus strokeWidth={1} />,
        path: "/create-request",
        activePaths: ["/create-request"],
        role: "customer",
      },
      {
        text: "Taleplerim",
        icon: <TbClipboardList strokeWidth={1} />,
        path: "/my-requests",
        activePaths: ["/my-requests"],
        role: "customer",
      },
      {
        text: "Tekliflerim",
        icon: <TbCreditCard strokeWidth={1} />,
        path: "/my-offers",
        activePaths: ["/my-offers"],
        role: "customer",
      },
      {
        text: "Operasyonlarım",
        icon: <TbCalendar strokeWidth={1} />,
        path: "/my-operations",
        activePaths: ["/my-operations"],
        role: "customer",
      },
      {
        text: "Talepler",
        icon: <TbUserShield strokeWidth={1} />,
        path: "/admin-requests",
        role: "admin",
      },
      {
        text: "Teklifler",
        icon: <TbUserShield strokeWidth={1} />,
        path: "/admin-offers",
        role: "admin",
      },
      {
        text: "Operasyonlar",
        icon: <TbCalendar strokeWidth={1} />,
        path: "/my-operations",
        role: "admin",
      },
    ],
  },
  {
    title: "Depolarım",
    items: [
      {
        text: "Depo Bilgilerim",
        icon: <TbBuildingWarehouse strokeWidth={1} />,
        path: "/my-warehouses",
        role: "customer",
      },
      {
        text: "Ödemelerim",
        icon: <TbCreditCard strokeWidth={1} />,
        path: "/my-payments",
        activePaths: ["/my-payments"],
        role: "customer",
      },
      {
        text: "Sözleşmelerim",
        icon: <TbFileInvoice strokeWidth={1} />,
        path: "/my-contracts",
        activePaths: ["/my-contracts"],
        role: "customer",
      },
      {
        text: "Firma Listesi",
        icon: <TbClipboardList strokeWidth={1} />,
        path: "/firm-list",
        role: "admin",
      },
      {
        text: "Depo Listesi",
        icon: <TbClipboardList strokeWidth={1} />,
        path: "/warehouse-list",
        role: "admin",
      },
    ],
  },
  {
    // Merchant: talep ve operasyon sayfaları. Admin'in "Kullanıcılar" bölümüyle
    // karışmaması için ayrı başlık altında durur.
    title: "Talep ve Operasyon Yönetimi",
    items: [
      {
        text: "Nakliye Talepleri",
        icon: <TbClipboardList strokeWidth={1} />,
        path: "/transport-requests",
        role: "merchant",
      },
      {
        text: "Operasyonlar",
        icon: <TbCalendar strokeWidth={1} />,
        path: "/my-operations",
        role: "merchant",
      },
    ],
  },
  {
    title: "Kullanıcılar",
    items: [
      {
        text: "Kullanıcılar",
        icon: <TbUserStar strokeWidth={1} />,
        path: "/users",
        role: "admin",
      },
      {
        text: "Müşteriler",
        icon: <TbUserStar strokeWidth={1} />,
        path: "/my-customers",
        role: "admin",
      },
    ],
  },
  {
    // Admin + merchant: ödeme ve sözleşme yönetimi "Müşteri Yönetimi" kategorisinde.
    title: "Müşteri Yönetimi",
    items: [
      {
        text: "Müşterilerim",
        icon: <TbUserStar strokeWidth={1} />,
        path: "/my-customers",
        role: "merchant",
      },
      {
        text: "Ödemeler",
        icon: <TbReceipt strokeWidth={1} />,
        path: "/payments",
        activePaths: ["/payments"],
        role: ["admin", "merchant"],
      },
      {
        text: "Sözleşmeler",
        icon: <TbFileInvoice strokeWidth={1} />,
        path: "/contracts",
        activePaths: ["/contracts"],
        role: ["admin", "merchant"],
      },
      {
        // Memnuniyet anketi davetleri: katıldı/katılmadı, cevaplar, telefonla yanıtlama
        // (yalnız admin). Yetki matrisine role "admin" olduğu için kendiliğinden girer;
        // müşteri ilişkileri rolünde default kapalı.
        text: "Memnuniyet",
        icon: <TbClipboardList strokeWidth={1} />,
        path: "/satisfaction",
        role: "admin",
      },
      {
        // Yalnız NAKLİYE firması merchant'ına görünür (aşağıdaki gating). Müşteri önerir.
        // "Talep ve Operasyon Yönetimi"nden buraya, Sözleşmeler'in altına taşındı.
        text: "Müşteri Öner",
        icon: <TbUserPlus strokeWidth={1} />,
        path: "/recommend-customer",
        role: "merchant",
      },
    ],
  },
  {
    // 2. El Mağaza: website /store'un panel karşılığı (tasarım aşaması, dummy veri).
    // Merchant'ta izin matrisine takılmaz — tüm merchant rollerine açık (bkz.
    // merchantItemVisible / ProtectedRoute / UserPermissions alwaysOpenKeys'teki "store").
    title: "Mağaza",
    items: [
      {
        text: "Mağaza",
        icon: <TbShoppingBag strokeWidth={1} />,
        path: "/store",
        activePaths: ["/store"],
        role: ["customer", "merchant"],
      },
      {
        // Admin: 2. el ilanlar — onay kuyruğu + tüm durumlar + düzenleme (16.10.2026: İlan Onayı ve
        // İlan Ekle tek menüde "İlanlar"; ilan ekleme sağ üstteki "İlan Ekle" butonundan açılır).
        // Yol /store altında DEĞİL — ProtectedRoute /store* yollarını yalnız müşteri/merchant'a açıyor.
        text: "İlanlar",
        icon: <TbListCheck strokeWidth={1} />,
        path: "/listing-approvals",
        activePaths: ["/listing-approvals", "/listing-create"],
        role: "admin",
      },
      {
        // Admin: mağaza ayarları (ilan ücreti, ücretsiz hak, nakliye indirimi, üst bant duyuruları, kategori listeleri).
        text: "Mağaza Ayarları",
        icon: <TbSettings strokeWidth={1} />,
        path: "/store-settings",
        role: "admin",
      },
      {
        // Admin: mağaza ödeme ekranındaki indirim kodlarını yönetir.
        text: "Promosyon Kodları",
        icon: <TbDiscount strokeWidth={1} />,
        path: "/promo-codes",
        role: "admin",
      },
      {
        // Admin: Troy Depo'nun kendi ürünleri için ilan (onaysız doğrudan yayına girer).
        // Menüde GÖRÜNMEZ (sidebarHidden) — İlanlar sayfasındaki "İlan Ekle" butonundan açılır;
        // yetki matrisinde ve rota kontrolünde (getAdminPages) yerinde kalır.
        text: "İlan Ekle",
        icon: <TbCirclePlus strokeWidth={1} />,
        path: "/listing-create",
        role: "admin",
        sidebarHidden: true,
      },
    ],
  },
  {
    title: "Panel Yönetimi",
    items: [
      {
        text: "Web Siteyi Düzenle",
        icon: <TbNotes strokeWidth={1} />,
        path: "/website-editor",
        role: "admin",
      },
      {
        text: "E-Posta ve Bildirim Listesi",
        icon: <TbMail strokeWidth={1} />,
        path: "/email-notifications",
        role: "admin",
      },
      {
        text: "Başvurular",
        icon: <TbClipboardCheck strokeWidth={1} />,
        path: "/admin-applications",
        role: "admin",
      },
      {
        text: "Ek Hizmetler",
        icon: <TbReceipt strokeWidth={1} />,
        path: "/additional-services",
        role: "admin",
      },
      {
        text: "Yetkilendirme",
        icon: <TbShieldLock strokeWidth={1} />,
        path: "/user-permissions",
        role: "admin",
      },
    ],
  },
  {
    title: "Destek",
    items: [
      { text: "TROYİ'ye Sor", icon: <TbRobot strokeWidth={1} />, path: "/ask-troyi", role: "customer" },
      { text: "Mesajlar", icon: <TbMessages strokeWidth={1} />, path: "/chat", role: "customer" },
      // Tavsiye sayfası — merchant'taki "Müşteri Öner" ile AYNI rota ve AYNI bileşen;
      // metinler ve kayıt izi rol'e göre değişir (bkz. RecommendCustomerPage PAGE_COPY,
      // users::recommendCustomer). Müşteride Mesajlar'ın hemen altında durur.
      {
        text: "Sevdiklerine Öner",
        icon: <TbUserPlus strokeWidth={1} />,
        path: "/recommend-customer",
        role: "customer",
      },
      // Müşteri bilgilendirmesi (Troy Depo Standartları) — Mesajlar'ın hemen altında.
      {
        text: "Bilgilendirme",
        icon: <TbBook strokeWidth={1} />,
        path: "/information",
        role: "customer",
      },
      // {
      //   text: "Destek Taleplerim",
      //   icon: <TbMessageCircleQuestion strokeWidth={1} />,
      //   path: "/ekmenu/10",
      // },
      // {
      //   text: "Hacim Hesaplama",
      //   icon: <TbCalculator strokeWidth={1} />,
      //   path: "/ekmenu/11",
      // },
      // S.S.S: merchant için aşağıdaki "Destek ve Ayarlar" bölümünde listelenir.
      {
        text: "S.S.S",
        icon: <TbInfoCircle strokeWidth={1} />,
        path: "/faq",
        role: ["customer", "admin"],
      },
      // {
      //   text: "İletişim",
      //   icon: <TbPhone strokeWidth={1} />,
      //   path: "/ekmenu/13",
      // },
    ],
  },
  {
    // Merchant'a özel bölüm: destek içerikleri + firma ayarları (Yetkilendirme) bir arada.
    title: "Destek ve Ayarlar",
    items: [
      {
        text: "Yetkilendirme",
        icon: <TbShieldLock strokeWidth={1} />,
        path: "/user-permissions",
        role: "merchant",
      },
      // Merchant iş ortakları için bilgilendirme dokümanları (izin matrisine takılmaz —
      // bkz. merchantItemVisible / ProtectedRoute'taki "merchant-information" istisnası).
      {
        text: "Bilgilendirme",
        icon: <TbBook strokeWidth={1} />,
        path: "/merchant-information",
        role: "merchant",
      },
      {
        text: "S.S.S",
        icon: <TbInfoCircle strokeWidth={1} />,
        path: "/faq",
        role: "merchant",
      },
    ],
  },
  {
    title: "Troyi",
    items: [
      {
        text: "Troyi Panel",
        icon: <TbRobot strokeWidth={1} />,
        path: "/troyi",
        exact: true,
        role: "admin",
      },
      {
        text: "Konuşmalar",
        icon: <TbMessages strokeWidth={1} />,
        path: "/troyi/conversations",
        activePaths: ["/troyi/conversations"],
        role: "admin",
      },
    ],
  },
];

// Admin sidebar'da bölüm (ana başlık) sırası
const ADMIN_SECTION_ORDER = [
  "Genel Bakış",
  // Kullanıcılar, eski "Firmalar" konumuna (Genel Bakış'ın hemen altına) alındı.
  "Kullanıcılar",
  "Talep Yönetimi",
  "Müşteri Yönetimi",
  // Firmalar, Müşteri Yönetimi'nin altına taşındı.
  "Firmalar",
  "Mesajlaşma",
  "Troyi",
  "Panel Yönetimi",
  "Destek",
];

// Tek bir string ya da array role desteği
function hasRole(requiredRole, userType) {
  if (!requiredRole) return true;
  if (Array.isArray(requiredRole)) return requiredRole.includes(userType);
  return requiredRole === userType;
}

// Route path'ten stabil pageKey üret: "/firm-list" -> "firm-list",
// "/troyi/conversations" -> "troyi/conversations"
export function pageKeyFromPath(path) {
  return String(path || "").replace(/^\//, "");
}

// Admin'in gördüğü sayfaların düz listesi — frontAuth yetki matrisinin DİNAMİK kaynağı.
// RAW_PAGE_LIST'te role'ü açıkça "admin" içeren her item otomatik dahil olur; yeni bir
// admin sayfası eklenince matriste elle iş yapmadan görünür. role'ü tanımsız (herkese
// açık, örn. S.S.S) sayfalar matrise dahil edilmez.
export function getAdminPages() {
  const pages = [];
  const seen = new Set();
  for (const section of RAW_PAGE_LIST) {
    for (const item of section.items) {
      if (item.role == null) continue;
      if (!hasRole(item.role, "admin")) continue;
      const key = pageKeyFromPath(item.path);
      if (!key || seen.has(key)) continue;
      seen.add(key);
      pages.push({
        key,
        text: item.text,
        title: section.title,
        path: item.path,
        capabilities: getCapabilities(key),
      });
    }
  }
  // Permission-only: "Depo Bilgilerim" sidebar'da müşteri sayfası ama admin
  // /my-warehouses/:userID ile erişip snapshot güncelleyebilir. Yetki matrisinde
  // görünmesi (ve admin default'unda açık olması) için elle ekleniyor.
  if (!seen.has("my-warehouses")) {
    seen.add("my-warehouses");
    pages.push({
      key: "my-warehouses",
      text: "Depo Bilgilerim",
      title: "Depolarım",
      path: "/my-warehouses",
      capabilities: getCapabilities("my-warehouses"),
    });
  }
  return pages;
}

// Müşterinin gördüğü sayfaların düz listesi. ProtectedRoute, "bu rota admin'e özel mi?"
// sorusunu yanıtlarken kullanır (admin listesinde olup merchant/müşteri listesinde olmayan
// rotalar admin'e özeldir).
export function getCustomerPages() {
  const pages = [];
  const seen = new Set();
  for (const section of RAW_PAGE_LIST) {
    for (const item of section.items) {
      if (item.role == null) continue;
      if (!hasRole(item.role, "customer")) continue;
      const key = pageKeyFromPath(item.path);
      if (!key || seen.has(key)) continue;
      seen.add(key);
      pages.push({ key, text: item.text, title: section.title, path: item.path });
    }
  }
  return pages;
}

// Merchant'ın gördüğü sayfaların düz listesi — merchant frontAuth yetki matrisinin
// DİNAMİK kaynağı. getAdminPages() muadili. role'ü merchant içeren her item dahil olur.
export function getMerchantPages() {
  const pages = [];
  const seen = new Set();
  for (const section of RAW_PAGE_LIST) {
    for (const item of section.items) {
      if (item.role == null) continue;
      if (!hasRole(item.role, "merchant")) continue;
      const key = pageKeyFromPath(item.path);
      if (!key || seen.has(key)) continue;
      seen.add(key);
      pages.push({
        key,
        text: item.text,
        title: section.title,
        path: item.path,
        capabilities: getMerchantCapabilities(key),
      });
    }
  }
  return pages;
}

export function usePageList() {
  const { userType, isContractLocked, merchantRole, merchantFrontAuth, merchantCompanyTypes, frontAuthRole, frontAuth, customerHasWarehouseEntry } = useAuth();

  const filtered = useMemo(() => {
    // Admin alt-rol (frontAuth) izinlerini hazırla: kayıtlı yetki yoksa rol default'una düş.
    const adminRole = normalizeRole(frontAuthRole);
    const adminSuper = userType === "admin" && isSuperadmin(adminRole);
    // superadmin → ALL_ACCESS (sınırsız); aksi halde kayıtlı yetki, yoksa rol default'u.
    const adminPermissions = adminSuper
      ? ALL_ACCESS
      : frontAuth && typeof frontAuth === "object" && Object.keys(frontAuth).length > 0
        // Sonradan eklenen sayfaların anahtarları kayıtlı yetkide yoksa rol default'undan tamamlanır.
        ? mergeMissingPagePermissions(frontAuth, adminRole, getAdminPages())
        : buildDefaultPermissions(adminRole, getAdminPages());

    // Admin için bir sidebar item'ı frontAuth'a göre görünür mü?
    const adminItemVisible = (item) => {
      if (userType !== "admin") return true;
      if (item.role == null) return true; // herkese açık sayfalar kısıtlanmaz
      const key = pageKeyFromPath(item.path);
      // S.S.S bilgilendirme sayfasıdır; izin matrisine dahil değildir.
      if (key === "faq") return true;
      if (key === "user-permissions") return canManagePermissions(adminPermissions, adminRole);
      return frontAuthCanView(adminPermissions, key);
    };

    // Normal rol filtreleme
    const byRole = RAW_PAGE_LIST
      .map((section) => ({
        ...section,
        title:
          userType === "customer" && section.title === "Talepler"
            ? "Taleplerim"
            : userType === "admin" && section.title === "Talepler"
              ? "Talep Yönetimi"
            : userType === "admin" && section.title === "Depolarım"
              ? "Firmalar"
            : section.title,
        items: section.items
          .filter((item) => hasRole(item.role, userType))
          .filter((item) => !item.sidebarHidden) // menüde gösterilmeyen sayfa (yetkisi getAdminPages'te durur)
          .filter(adminItemVisible)
          // Müşterinin hiç depo girişi (aktif ya da pasif) yoksa "Depo Bilgilerim" boş
          // bir sayfaya çıkar; bu durumda menüde hiç gösterilmez. Henüz bilinmiyorsa
          // (null/loading) gösterilmeye devam edilir, kesin "yok" sonucunda gizlenir.
          .filter((item) => !(userType === "customer" && item.path === "/my-warehouses" && customerHasWarehouseEntry === false))
          .map((item) => {
            if (item.path === "/my-customers") {
              return {
                ...item,
                text: userType === "admin" ? "Müşteriler" : "Müşterilerim",
              };
            }
            return item;
          }),
      }))
      .filter((section) => section.items.length > 0);

    const hasDepoType = merchantHasDepoType(merchantCompanyTypes);
    const hasNakliyeType = merchantHasNakliyeType(merchantCompanyTypes);

    // Merchant frontAuth izinleri: kayıtlı yetki yoksa rol default'una düş (geriye dönük uyum).
    const merchantNormalizedRole = normalizeMerchantRole(merchantRole);
    // Kayıtlı yetkide BULUNMAYAN sayfa anahtarları rol varsayılanından tamamlanır — rota
    // kapısındaki useMerchantFrontAuth ile AYNI kural. Tamamlama yapılmadığı için menü ile
    // rota ayrışıyordu (sayfaya girilebiliyor ama menüde görünmüyordu).
    const merchantPermissions =
      merchantFrontAuth && typeof merchantFrontAuth === "object" && Object.keys(merchantFrontAuth).length > 0
        ? mergeMissingMerchantPagePermissions(merchantFrontAuth, merchantNormalizedRole)
        : buildMerchantDefaultPermissions(merchantNormalizedRole);

    // Merchant için bir sidebar item'ı frontAuth'a göre görünür mü?
    const merchantItemVisible = (item) => {
      if (item.role == null) return true; // herkese açık sayfalar (S.S.S) kısıtlanmaz
      const key = pageKeyFromPath(item.path);
      // Anasayfa ve Bilgilendirme: tüm merchant rollerine açık; izin matrisine dahil değil.
      if (key === "homepage" || key === "merchant-information" || key === "ask-troyi" || key === "faq" || key === "recommend-customer") return true;
      if (key === "user-permissions") return canManageMerchantPermissions(merchantPermissions, merchantNormalizedRole);
      return merchantCanView(merchantPermissions, key);
    };

    const filteredByMerchantRole =
      userType === "merchant"
        ? byRole
            .map((section) => ({
              ...section,
              items: section.items.filter((i) => {
                if (!hasDepoType && (i.path === "/my-customers" || i.path === "/warehouse-list")) return false;
                if (!hasNakliyeType && i.path === "/transport-requests") return false;
                // Müşteri Öner artık TÜM firma tiplerine açık (depo, nakliye, depo+nakliye).
                // Eski "yalnız saf nakliye firması" kısıtı kaldırıldı.
                return true;
              }).filter(merchantItemVisible),
            }))
            .filter((section) => section.items.length > 0)
        : byRole;

    // Sözleşme kilitliyse → YALNIZCA "Şirket Bilgilerim"
    // Rol ne olursa olsun (admin, alt-rol, legacy/rolsüz "member") her merchant en az
    // "Şirket Bilgilerim"i görmeli: sözleşmeler oraya bağlı olduğu için kilidi açmanın TEK
    // yolu orası. Eskiden admin-olmayan merchant tamamen boş menüyle dead-end oluyordu.
    if (isContractLocked) {
      const onlyCompany = byRole
        .map((section) => ({
          ...section,
          items: section.items.filter((i) => i.path === "/my-warehouse-firm"),
        }))
        .filter((section) => section.items.length > 0);

      return onlyCompany;
    }

    // Admin'de bölüm sırasını sabit düzene göre yeniden sırala
    if (userType === "admin") {
      return [...filteredByMerchantRole].sort(
        (a, b) =>
          ADMIN_SECTION_ORDER.indexOf(a.title) -
          ADMIN_SECTION_ORDER.indexOf(b.title)
      );
    }

    // Müşteri ve merchant'ta "Mesajlaşma" bölümü "Destek" başlığının hemen üstüne taşınır.
    if (userType === "customer" || userType === "merchant") {
      // Müşteride bölüm "Destek", merchant'ta "Destek ve Ayarlar" adını taşır.
      const isSupportTitle = (t) => t === "Destek" || t === "Destek ve Ayarlar";
      const messagingIndex = filteredByMerchantRole.findIndex((section) => section.title === "Mesajlaşma");
      const supportIndex = filteredByMerchantRole.findIndex((section) => isSupportTitle(section.title));
      if (messagingIndex !== -1 && supportIndex !== -1 && messagingIndex !== supportIndex - 1) {
        const reordered = [...filteredByMerchantRole];
        const [messagingSection] = reordered.splice(messagingIndex, 1);
        const insertAt = reordered.findIndex((section) => isSupportTitle(section.title));
        reordered.splice(insertAt, 0, messagingSection);
        return reordered;
      }
    }

    return filteredByMerchantRole;
  }, [userType, isContractLocked, merchantRole, merchantFrontAuth, merchantCompanyTypes, frontAuthRole, frontAuth, customerHasWarehouseEntry]);

  return filtered;
}
